export default __webpack_public_path__ + "static/media/enhance-1.26bca0e3.png";